import { clientLog } from 'nike-ui/src/common/logging/logs';
import { BotDefenceLog } from 'nike-ui/src/common/logging/BotDefenceLog';

const TOO_MANY_REQEUSTS_CODE = 429;

function createRetryRejector(axiosInstance, botDefenceInstance) {
    return function(error) {
        if (error && error.config && error.response && error.response.status === TOO_MANY_REQEUSTS_CODE) {
            if (typeof error.config.metaRetryCount === 'number' && error.config.metaRetryCount > 2) {
                clientLog(
                    BotDefenceLog({
                        message: `BD Snapshot request returned ${TOO_MANY_REQEUSTS_CODE} (giving up after 3 retries)`,
                        data: error?.config?.params ?? {}
                    })
                );

                return Promise.reject(error);
            }
            clientLog(
                BotDefenceLog({
                    message: `BD Snapshot request returned ${TOO_MANY_REQEUSTS_CODE}`,
                    data: error?.config?.params ?? {}
                })
            );

            error.config.metaRetryCount = (error.config.metaRetryCount || 0) + 1;
            return botDefenceInstance.forceChallenge().then(() => axiosInstance.request(error.config));
        }

        return Promise.reject(error);
    };
}

export default createRetryRejector;
